import { fuseFilter, nullOrUndefined } from '@/plugins/fuse'
import { SSharedList } from '@/services/shared'
import QUERY from 'lodash'

export default {
  data () {
    return {
      fetching: {
        barangays: false
      },
      options: {
        barangays: []
      },
      selected: {
        barangay: ''
      },
      editable: {
        barangay: ''
      }
    }
  },

  watch: {
    'selected.municipality' (municipality) {
      if (municipality?.id) {
        this.getBarangays(this, '', municipality.id).finally(() => {
          if (this.editable.barangay) {
            this.selected.barangay = QUERY.find(this.options.barangays, {
              id: this.editable.barangay
            }) || ''
            this.editable.barangay = ''
          }
        })
      } else {
        this.selected.barangay = ''
        this.options.barangays = []
      }
    }
  },

  methods: {

    async getBarangays (context, search = '', municipality = '') {
      const selectedContext = context?.selected
      const fetchingContext = context?.fetching
      const optionsContext = context?.options

      if (nullOrUndefined(selectedContext) || nullOrUndefined(fetchingContext) || nullOrUndefined(optionsContext)) {
        throw Error('Invalid context object')
      }

      const selected = context.selected?.barangay
      const fetching = context.fetching?.barangays
      const options = context.options?.barangays

      if (nullOrUndefined(selected) || nullOrUndefined(fetching) || nullOrUndefined(options)) {
        throw Error('Invalid context object')
      }

      context.fetching.barangays = true
      context.selected.barangay = ''

      const filters = {
        filter_text: search,
        municipality_id: municipality
      }

      return await SSharedList.getBarangays(filters).then(
        ({ data }) => {
          context.options.barangays = data
        }
      ).catch(() => {
        context.options.barangays = []
      }).finally(() => {
        context.fetching.barangays = false
      })
    },

    async searchBarangays (search, loading) {
      this.searchBarangaysProvider(this, search, loading)
    },

    searchBarangaysProvider: QUERY.debounce(
      ({ options, selected }, search, loading) => {
        const filteredOptions = fuseFilter(search, options.barangays, {
          keys: ['barangay_name']
        })

        if (filteredOptions.length < 1) {
          loading(true)

          const filters = {
            filter_text: search,
            municipality_id: selected.municipality?.id || ''
          }

          SSharedList.getBarangays(filters).then(
            ({ data }) => {
              options.barangays = data
            }
          ).catch(() => {
            options.barangays = []
          }).finally(() => {
            loading(false)
          })
        }
      }, 500
    )
  }
}
